import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { RoutesPaths } from "../Router/constant";
import { registerAdmin } from "../Services/userService";

const styles = {
  container: {
    padding: 20,
  },

  heading: {
    fontSize: "18px",
    fontWeight: "600",
    marginBottom: "20px",
    color: "#333",
  },

  form: {
    backgroundColor: "#fff",
    padding: "30px 25px",
    borderRadius: 8,
    boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
  },

  row: {
    display: "flex",
    gap: 15,
    marginBottom: 25,
  },

  box: {
    flex: 1,
  },

  label: {
    fontSize: 14,
    marginBottom: 5,
    display: "block",
    fontWeight: "500",
  },

  input: {
    width: "100%",
    padding: "12px",
    borderRadius: 6,
    border: "1px solid #ddd",
    fontSize: 14,
    outline: "none",
  },

  buttonWrapper: {
    display: "flex",
    justifyContent: "flex-end",
    gap: 10,
    marginTop: 30,
  },

  cancelBtn: {
    backgroundColor: "#fff",
    color: "#333",
    padding: "10px 25px",
    border: "1px solid #ddd",
    borderRadius: 6,
    fontSize: 16,
    cursor: "pointer",
  },

  submitBtn: {
    backgroundColor: "#ff4d2d",
    color: "#fff",
    padding: "10px 25px",
    border: "none",
    borderRadius: 6,
    fontSize: 16,
    cursor: "pointer",
  },
};

export default function CreateAdmin() {
  const navigate = useNavigate();

  const [submitLoader, setSubmitLoader] = useState(false);

  const [adminDetails, setAdminDetails] = useState({
    fullName: "",
    email: "",
  });

  const validateEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setAdminDetails((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const fullName = adminDetails.fullName.trim();
    const email = adminDetails.email.trim();

    if (!fullName) {
      toast.error("Please enter full name");
      return;
    }

    if (!email) {
      toast.error("Please enter email");
      return;
    }

    if (!validateEmail(email)) {
      toast.error("Please enter a valid email");
      return;
    }

    const payload = {
      fullName,
      email,
    };

    try {
      setSubmitLoader(true);

      const response = await registerAdmin(payload);

      console.log("Register admin response:", response);

      if (
        response?.data?.success === true ||
        response?.data?.status === true ||
        response?.status === 200 ||
        response?.status === 201
      ) {
        toast.success(
          response?.data?.message ||
            response?.data?.data?.message ||
            "Admin created successfully"
        );

        setAdminDetails({
          fullName: "",
          email: "",
        });

        navigate(RoutesPaths.ADMINMANAGEMENT);
      } else {
        toast.error(
          response?.data?.message ||
            "Failed to create admin"
        );
      }
    } catch (error) {
      console.error("Create admin error:", error);

      toast.error(
        error?.response?.data?.message ||
          error?.response?.data?.data?.message ||
          "Failed to create admin"
      );
    } finally {
      setSubmitLoader(false);
    }
  };

  return (
    <div style={styles.container}>

      {/* Breadcrumb */}
      <div className="logisticsMenu">
        <p>
          <NavLink to={RoutesPaths.DASHBOARD}>
            <img
              src="/assets/img/homeIcon.svg"
              alt=""
            />
          </NavLink>
        </p>

        <img
          src="/assets/img/chevron-right.svg"
          alt=""
        />

        <p>
          <NavLink
            to={RoutesPaths.ADMINMANAGEMENT}
            style={{ cursor: "pointer" }}
          >
            Admin management
          </NavLink>
        </p>

        <img
          src="/assets/img/chevron-right.svg"
          alt=""
        />

        <p className="m-0">
          Create new admin
        </p>
      </div>

      {/* Form */}
      <div style={{ marginTop: "20px" }}>
        <div style={styles.form}>

          <h3 style={styles.heading}>
            Create new admin
          </h3>

          <form onSubmit={handleSubmit}>

            <div style={styles.row}>

              {/* Full Name */}
              <div style={styles.box}>
                <label style={styles.label}>
                  Full name *
                </label>

                <input
                  type="text"
                  name="fullName"
                  style={styles.input}
                  placeholder="Enter full name"
                  value={adminDetails.fullName}
                  onChange={handleChange}
                  disabled={submitLoader}
                />
              </div>

              {/* Email */}
              <div style={styles.box}>
                <label style={styles.label}>
                  Email *
                </label>

                <input
                  type="email"
                  name="email"
                  style={styles.input}
                  placeholder="Enter email"
                  value={adminDetails.email}
                  onChange={handleChange}
                  disabled={submitLoader}
                />
              </div>

            </div>

            {/* Buttons */}
            <div style={styles.buttonWrapper}>

              <button
                type="button"
                style={styles.cancelBtn}
                onClick={() =>
                  navigate(RoutesPaths.ADMINMANAGEMENT)
                }
                disabled={submitLoader}
              >
                Cancel
              </button>

              <button
                type="submit"
                style={{
                  ...styles.submitBtn,
                  opacity: submitLoader ? 0.7 : 1,
                  cursor: submitLoader
                    ? "not-allowed"
                    : "pointer",
                }}
                disabled={submitLoader}
              >
                {submitLoader
                  ? "Creating..."
                  : "Create admin"}
              </button>

            </div>

          </form>

        </div>
      </div>
    </div>
  );
}